import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)


//运营端 -管理系统2
import SystemLogin from '@/view/system/login'
import SystemIndex from '@/view/system/index'
import HomeIndex from '@/view/system/homeIndex'
import NewsList from '@/view/system/newsList'

const routes = [
  {
    path: '',
    redirect: '/system'
  },
  {
    path: '/system',
    name: 'login',
    component: SystemLogin,
  },
  {
    path: '/system/home',
    component: SystemIndex,
    meta: {
      sysType: 'login',
    }, children: [
      {
        path: 'index',
        name: 'index',
        component: HomeIndex,
        meta: {
          anotherName: '首页',
          type: 'login',
          affixType: true
        },
      },
      {
        path: 'newsList',
        name: 'newsList',
        component: NewsList,
        meta: {
          anotherName: '新闻资讯',
          type: 'login',
        },
      },
    ]
  }
]


const router = new VueRouter({
  mode: 'history',
  scrollBehavior: () => ({
    y: 0
  }),
  routes
})
export default router



// WEBPACK FOOTER //
// ./src/router/router.js